import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox/';
import { Tooltip } from 'ui-components/components/tooltip';
import { noop } from 'ui-components/default-props/noop';

import { useCountryConfig } from '../../../../hooks/use-country-config';
import { CountryConfigNames } from '../../../../contexts/country-config-context/country-config-enums';
import { useBillDutiesAndTaxesToPayor } from '../../../../hooks/use-seller-setting';
import { useShouldShowDdp } from '../../use-should-show-ddp';

import messages from './messages';
import style from './inputs.module.less';

type DeliveredDutyPaidOptionProps = {
  label: string;
  checked?: boolean;
  onCheck?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
  fulfillmentPlanId: string;
};

export const DeliveredDutyPaidOption = ({ label, checked = false, onCheck = noop, fulfillmentPlanId }: DeliveredDutyPaidOptionProps) => {
  const intl = useIntl();
  const shouldShowDdp = useShouldShowDdp(fulfillmentPlanId);
  const isDdpSellerSettingsEnabled = useBillDutiesAndTaxesToPayor();
  const [isDdpWarningEnabled] = useCountryConfig(CountryConfigNames.ShowsDdpImportDutiesWarning);

  if (!shouldShowDdp) {
    return null;
  }

  const shouldShowTooltip = isDdpWarningEnabled || isDdpSellerSettingsEnabled;

  // Import duties warning takes priority over seller settings tooltip
  const tooltipMessage = isDdpWarningEnabled ? messages.importDutiesWarning : messages.billToSenderTooltip;

  return (
    <div className={style['default-option']}>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {shouldShowTooltip ? (
        <Tooltip text={intl.formatMessage(tooltipMessage)}>
          <div className={style['information-icon']}>
            <FontAwesomeIcon icon={faQuestionCircle} />
          </div>
        </Tooltip>
      ) : null}
    </div>
  );
};
